export default __webpack_public_path__ + "static/Plots0016-00f54bb18f65e6f936080f2773203a2f.jpg";